<template>
  <div class="form-group" :class="{ 'has-error': errors.has(validationName) }">
    <label class="control-label" v-if="label">{{ label }}</label>
    <date-picker
      ref="input"
      :class="['form-control']"
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :name="name"
      :readonly="readonly"
      :disabled="disabled"
      :required="required"
      :data-vv-as="label"
      :data-vv-name="name"
      :config="config"
      v-mask="mask"
      masked="true"
      @input="$emit('input', $event)"
      @blur="$emit('blur', $event), changeFocus()"
      @focus="changeFocus()"
    ></date-picker>
    <error-message :message="errors.first(validationName)"></error-message>
  </div>
</template>

<script>
import datePicker from "vue-bootstrap-datetimepicker";
import "eonasdan-bootstrap-datetimepicker-npm/build/css/bootstrap-datetimepicker.css";

export default {
  inject: ["$validator"],
  name: "form-group-date-time-picker",
  props: {
    label: String,
    type: {
      type: String,
      default: "text",
      validate: val => {
        return ["text"].indexOf(val) !== -1;
      }
    },
    id: String,
    name: String,
    scope: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: [String, Date],
    mask: {
      type: String,
      default: "##/##/####"
    },
    config: {
      default: () => ({})
    }
  },
  components: {
    datePicker
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    validationName() {
      return this.scope ? `${this.scope}.${this.name}` : this.name;
    }
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupDateTimePicker.vue